import { State, Action, StateContext, Selector } from "@ngxs/store";
import { SovereignDetailsService } from "./service";
import { ISovereignDetails, ISovereignDetailsState } from "./types";
import { SetFiltersBasedOnTab, SetSearchField } from "./actions";
import { tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { IPagination } from "../../../../modules/authorization/store/types";

const defaults: ISovereignDetailsState = {
    isLoading: false,
    searchField: "",
    sovereignDetails: null,
    sovereignDetailsFilters: {
        page: 1,
        results: 100,
        sort: "",
    },
};

@State<ISovereignDetailsState>({
    name: "sovereignDetails",
    defaults,
})
@Injectable()
export class SovereignDetailsState {
    @Selector()
    static isLoading(state: ISovereignDetailsState) {
        return state.isLoading;
    }

    @Selector()
    static searchField(state: ISovereignDetailsState) {
        return state.searchField;
    }

    @Selector()
    static sovereignDetails(state: ISovereignDetailsState) {
        return state.sovereignDetails;
    }

    @Selector()
    static sovereignDetailsFilters(state: ISovereignDetailsState) {
        return state.sovereignDetailsFilters;
    }

    constructor(private sovereignDetailsService: SovereignDetailsService) {}

    @Action(SetSearchField)
    SetSearchField(
        ctx: StateContext<ISovereignDetailsState>,
        action: SetSearchField
    ) {
        ctx.patchState({ searchField: action.value });
        ctx.dispatch(new SetFiltersBasedOnTab({ page: 1 }));
    }

    @Action(SetFiltersBasedOnTab)
    SetFiltersBasedOnTab(
        ctx: StateContext<ISovereignDetailsState>,
        action: SetFiltersBasedOnTab
    ) {
        let state = ctx.getState();
        ctx.patchState({ isLoading: true });
        ctx.patchState({
            sovereignDetailsFilters: {
                ...state.sovereignDetailsFilters,
                ...action.filters,
            },
        });
        state = ctx.getState();
        return this.sovereignDetailsService
            .fetchAll({
                ...state.sovereignDetailsFilters,
                search: state.searchField,
            })
            .pipe(
                tap((pagination: IPagination<ISovereignDetails>) =>
                    ctx.patchState({
                        sovereignDetails: pagination,
                        isLoading: false,
                    })
                )
            );
    }
}
